import {DIGITAL_PROFILE_SETTINGS, DIGITAL_PROFILE_CABINET_LOADED} from '../store/actionTypes';

export const digitalProfileSettings = (state = {}, action) => {
    switch (action.type) {
        case DIGITAL_PROFILE_SETTINGS:
            return action.object;
        default:
            return state;
    }
};
export const digitalProfileCabinetLoaded = (state = false, action) => {
    switch (action.type) {
        case DIGITAL_PROFILE_CABINET_LOADED:
            return action.status;
        default:
            return state;
    }
};
